// extracted by mini-css-extract-plugin
module.exports = {"ZoomButtons":"ZoomButtons_ZoomButtons__HjCI2"};